import React from 'react';
import { useTranslation } from 'react-i18next';
import { AudioVisualiser } from '../AudioVisualiser';
import {
  VoiceControlsContainer,
  UnmuteIcon,
  LeaveVoiceButton,
  DisabledMicrophoneContainer,
  MicrophoneIconButton,
} from './styles';

type ControlPanelProps = {
  handleLeaveChat(): void;
  microphoneButtonDisabled?: boolean;
  isMicrophoneEnabled?: boolean;
  roomEstablished?: boolean;
  onClickMuteButton?(): void;
  onClickUnmuteButton?(): void;
};

export const ControlPanel = ({
  handleLeaveChat,
  microphoneButtonDisabled,
  isMicrophoneEnabled,
  roomEstablished,
  onClickMuteButton,
  onClickUnmuteButton,
}: ControlPanelProps) => {
  const { t: translate } = useTranslation('chatbot');

  const MicrophoneButton = () => {
    const labelKey = isMicrophoneEnabled
      ? 'voice.mute_microphone.label'
      : 'voice.unmute_microphone.label';
    const onClick = isMicrophoneEnabled
      ? onClickMuteButton
      : onClickUnmuteButton;

    return (
      <MicrophoneIconButton
        variant="primary"
        icon={isMicrophoneEnabled ? 'microphone-on' : 'microphone-off'}
        screenreaderText={translate(labelKey)}
        onClick={onClick}
        className="microphone-voice-button"
      />
    );
  };

  return (
    <VoiceControlsContainer>
      {microphoneButtonDisabled ? (
        <DisabledMicrophoneContainer>
          <UnmuteIcon />
        </DisabledMicrophoneContainer>
      ) : (
        <MicrophoneButton />
      )}
      {roomEstablished ? <AudioVisualiser /> : <div />}
      <LeaveVoiceButton
        variant="primary"
        icon="close"
        screenreaderText={translate('conversation.leave_chat_button.label')}
        onClick={handleLeaveChat}
        className="leave-voice-button"
      />
    </VoiceControlsContainer>
  );
};
